import { emitCacheCartNumber } from '@common/application/utils/cart-number';
import { ServerSide } from '@common/application/utils/server-side';
import { useAsyncEffect } from 'ahooks';
import type { GetServerSidePropsContext, NextPage } from 'next';

import { CustomLayout } from '@/components/common/custom-layout';
import { Breadcrumbs } from '@/components/page/product-diff/breadcrumbs';
import { DiffTable } from '@/components/page/product-diff/diff-table';

export async function getServerSideProps(
  ctx: GetServerSidePropsContext<{
    csku: string;
  }>
) {
  try {
    const i18nProps = await ServerSide.getTranslations(ctx, ['common', 'product-diff']);

    return {
      props: {
        ...i18nProps
      }
    };
  } catch (err) {
    return ServerSide.createException(ctx, err);
  }
}

const ProductDiffPage: NextPage = () => {
  useAsyncEffect(emitCacheCartNumber, []);

  return (
    <CustomLayout>
      <Breadcrumbs />
      <DiffTable />
    </CustomLayout>
  );
};

export default ProductDiffPage;
